import { LIBRARY_CALLS_API } from '@/shared/api/library';

const LINKED_MEDIA_UPLOAD_POLL_INTERVAL_MS = 3000;
// TODO: Investigate the number of safe attempts for video uploads in the primary flow and the continuous landing flow.
const MAX_POLL_ATTEMPTS = Infinity;

const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

type PollLinkedMediaUploadStatusOptions = {
  intervalMs?: number;
  maxAttempts?: number;
  onStatusCheckError?: (error: unknown) => void;
};

export const pollLinkedMediaUploadStatus = async (
  mediaId: string,
  options: PollLinkedMediaUploadStatusOptions = {},
): Promise<'failed' | 'ready' | 'timeout'> => {
  const {
    intervalMs = LINKED_MEDIA_UPLOAD_POLL_INTERVAL_MS,
    maxAttempts = MAX_POLL_ATTEMPTS,
    onStatusCheckError,
  } = options;

  let attempts = 0;

  while (attempts < maxAttempts) {
    attempts++;

    try {
      const status = await LIBRARY_CALLS_API.getLinkedMediaUploadStatus(mediaId);

      if (status.status === 'ready') {
        return 'ready';
      }

      if (status.status === 'failed') {
        return 'failed';
      }
    } catch (error) {
      onStatusCheckError?.(error);
    }

    await wait(intervalMs);
  }

  return 'timeout';
};
